<div class="w-[100%] h-[200px mt-[30px] px-4">
  <p
    class="lg:text-[28px] md:text-[28px] sm:text-[24px] text-[20px] font-bold text-[#b6b6b6] text-center">
    {{ warningMessage }}
  </p>
</div>
